import { lazy } from 'react'
import { RouteObject } from 'react-router-dom'
import SuspenseWrapper from '@/components/common/wrappers/SuspenseWrapper.tsx'

const ProtectedRoute = lazy(() => import('@/components/common/wrappers/ProtectedRoute.tsx'))
const StartWizard = lazy(() => import('@/routes/start/view/StartWizard.tsx'))
const NoStageYet = lazy(() => import('@/routes/start/view/NoStageYet.tsx'))
const StartShell = lazy(() => import('@/routes/start/view/StartShell.tsx'))

/**
 * Full-screen onboarding pages. They sit beside the `/` app shell, not inside it: a user
 * who lands here has no stage, so the shell's navigation would have nothing to show, and
 * the root loader would fetch stage data that does not exist.
 */
export const startRoutes = (): RouteObject[] => [
  {
    // No `allowedRoles` here: ProtectedRoute reads the role from the store before
    // StartShell has synced it. StartWizard checks the role from the fetched user.
    element: (
      <SuspenseWrapper>
        <ProtectedRoute>
          <StartShell />
        </ProtectedRoute>
      </SuspenseWrapper>
    ),
    children: [
      { path: 'start', element: <StartWizard /> },
      { path: 'no-construction-site', element: <NoStageYet /> },
    ],
  },
]
